import React from "react";
import * as Yup from "yup";

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
const phoneRegex = /^\d{10}$/; 
const usernameRegex = /^[^\s]*$/;

const editUser = {
  // userName: Yup.string().required("Required"), // Not needed for edit
  // password: Yup.string().required("Required"), // Not needed for edit
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  gender: Yup.string().required("Required"),
  // joinDate: Yup.date().required("Required"), // Not needed for edit
  // endDate: Yup.date().required("Required"),   // Not needed for edit
  acctType: Yup.string().required("Required"),
  stsCd: Yup.string().required("Required"),
  phone: Yup.string()
    .matches(/^\d{10,13}$/, "Phone number must be 10 to 13 digits.")
    .required("Required"),
  email: Yup.string()
    .matches(emailRegex, "Invalid email format")
    .required("Required"),
  city: Yup.string().required("Required"),
  addressLine1: Yup.string().required("Required"),
  addressLine2: Yup.string(),
  state: Yup.string().required("Required"),
  country: Yup.string().required("Required"),
  zip: Yup.string()
    .matches(/^\d{5,6}$/, "Zip code must be 5 or 6 digits.")
    .required("Required"),
  // reportsTo: Yup.string().required("Required"), // Not needed for edit
};

export const getValuesFromLocalstorage = (storageKey) => {
  const userDetails =
    storageKey === "accessToken"
      ? localStorage.getItem(storageKey)
      : JSON.parse(localStorage.getItem(storageKey));

  return userDetails || null;
};

export const SignupSchema = Yup.object().shape({
  userName: Yup.string().required("Username is Required"),
  password: Yup.string("Enter your password")
    .min(7, "Password should be 7 characters length")
    .required("Password is Required")
    .matches(passwordRegex, "Password don't matches criteria "),
});

export const ForgotPasswordSchema = Yup.object().shape({
  // email: Yup.string().email("Email is Required"),
  email: Yup.string()
    .required("Email is required")
    .matches(emailRegex, "This is not a valid email"),
});

export const ResetPasswordSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(8, "New Password is too short")
    .max(25, "New Password is too long")
    .required("Password is Required")
    .matches(passwordRegex, "Password don't matches criteria "),

  confirmPassword: Yup.string()
    .min(8, "New Password is too short")
    .max(25, "New Password is too long")
    .required("Password is Required")
    // .matches(passwordRegex,"Password don't matches")
    .oneOf([Yup.ref("newPassword"), null], "passwords must match"),
});

export const UpdatePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string("old password is required").matches(
    passwordRegex,
    "Password don't matches criteria "
  ),
  newPassword: Yup.string()
    .min(6, "New Password is too short")
    .max(25, "New Password is too long")
    .required("Password is Required")
    .matches(passwordRegex, "Password don't matches criteria "),
  confirmPassword: Yup.string()
    .min(6, "New Password is too short")
    .max(25, "New Password is too long")
    .required("Password is Required")
    .oneOf([Yup.ref("newPassword"), null], "passwords must match"),
});
export const EditUserSchema = Yup.object(editUser);
export const AddUserSchema = Yup.object({
  ...editUser,
  // password: Yup.string().required("Required"),
  password: Yup.string()
    .matches(
      passwordRegex,
      "Password must be at least 8 characters, contain one uppercase letter, one number, and one special character"
    )
    .required("Required"),
});

const editClient = {
  name: Yup.string().required("Client Name is required"),
  addressLine1: Yup.string().required("Address is required"),
  addressLine2: Yup.string(),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  country: Yup.string().required("Country is required"),
  zip: Yup.string().required("ZIP is required"),
};

export const clientValidationSchema = Yup.object({
  clientName: Yup.string().required("Client Name is required"),
  clientLocation: Yup.string().required("Client Location is required"),
  jobTitle: Yup.string().required("Job Title is required"),
  rate: Yup.number()
    .typeError("Rate must be a number")
    .required("Rate is required")
    .test("is-decimal", "Rate must be a decimal value", value =>
      value === undefined || value === null || value === "" ? false : /^\d+(\.\d+)?$/.test(value.toString())
    ),
  status: Yup.string().required("Status is required"),
  vendor: Yup.string().required("Vendor is required"),
  notes: Yup.string()
});

export const EditClientSchema = Yup.object(editClient);
export const AddClientSchema = Yup.object(editClient);

export const manageEmployee = {
  firstName: Yup.string()
    .required("First Name is required")
    .min(2, "First Name must be at least 2 characters"),

  lastName: Yup.string()
    .required("Last Name is required")
    .min(1, "Last Name must be at least 1 character"),

  gender: Yup.string()
    .oneOf(["Male", "Female"], "Select either Male or Female")
    .required("Gender is required"),

  status: Yup.string()
    .oneOf(["Active", "Deactive"], "Select either Active or Deactive")
    .required("Status is required"),

  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),

  phoneNumber: Yup.string()
    .test(
      "phone-digits",
      "Phone number must be 10 to 13 digits and can include numbers, spaces, and special characters (+, -, (, )).",
      value => {
        const digits = (value || "").replace(/\D/g, "");
        return digits.length >= 10 && digits.length <= 13;
      }
    )
    .required("Phone Number is required"),

  technology: Yup.string()
    .required("Technology is required"),

  company: Yup.string()
    .required("Company is required"),
  
    
};
// ✅ Wrap your field definitions with Yup.object()
export const AddEmployeeSchema = Yup.object({
  firstName: Yup.string()
    .required("First Name is required")
    .min(2, "First Name must be at least 2 characters"),

  lastName: Yup.string()
    .required("Last Name is required")
    .min(1, "Last Name must be at least 1 character"),

  gender: Yup.string()
    .oneOf(["M", "F"], "Select either Male or Female")
    .required("Gender is required"),

  status: Yup.string()
    .oneOf(["A", "D"], "Select either Active or Deactive")
    .required("Status is required"),

  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),

  phoneNumber: Yup.string()
    .test(
      "phone-digits",
      "Phone number must be 10 to 13 digits and can include numbers, spaces, and special characters (+, -, (, )).",
      value => {
        const digits = (value || "").replace(/\D/g, "");
        return digits.length >= 10 && digits.length <= 13;
      }
    )
    .required("Phone Number is required"),

  technology: Yup.string().required("Technology is required"),

  company: Yup.string().required("Company is required"),
});
export const EditManageEmployeeSchema = Yup.object(manageEmployee);


export const employeeValidationSchema = Yup.object({
  userName: Yup.string().required("User Name required"),
  password: Yup.string().required("Password required"),
  firstName: Yup.string().required("First Name required"),
  lastName: Yup.string().required("Last Name required"),
  email: Yup.string().required("Email is required"),
  Gender: Yup.string().required("Gender is required"),
  joinDate: Yup.date().required("Join Date is required"),
  endDate: Yup.date().required("End Date is required"),
  phone: Yup.string().required("Phone Number is required"),
  accountType: Yup.string().required("Account type is required"),
  status: Yup.string().required("status is required"),
  reportsTo: Yup.string().required("Reporting to is required"),
  address1: Yup.string().required("Address is required"),
  address2: Yup.string(),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  country: Yup.string().required("Country is required"),
  zip: Yup.string().required("Zip required"),
});

export const editvalidationSchema = Yup.object({
  userName: Yup.string().required("Required"),
  password: Yup.string().required("Required"),
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  gender: Yup.string().required("Required"),
  joinDate: Yup.date().required("Required"),
  endDate: Yup.date(),
  accountType: Yup.string().required("Required"),
  status: Yup.string().required("Required"),
  phone: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  address: Yup.string().required("Required"),
  city: Yup.string().required("Required"),
  state: Yup.string().required("Required"),
  country: Yup.string().required("Required"),
  zip: Yup.string().required("Required"),
  reportsTo: Yup.string().required("Required"),
});

export const documentSchema = Yup.object().shape({
  documentType: Yup.string().required('Document type is required'),
  file: Yup.mixed().required('File is required'),
  statusCode: Yup.string().required('Status is required'),
  
  // Fix for "branch is not a function" error - proper way to use conditional validation
  others: Yup.string().when('documentType', {
    is: 'OTHER',
    then: () => Yup.string().required('Please specify document type'),
    otherwise: () => Yup.string().notRequired()
  }),
  
  // Conditionally require dates for specific document types
  issueDate: Yup.string().when('documentType', {
    is: (documentType) => ['PASSPORT', 'VISA', 'driving_license', 'SSN'].includes(documentType),
    then: () => Yup.string().required('Issue date is required for this document type'),
    otherwise: () => Yup.string().notRequired()
  }),
  
  expiryDate: Yup.string().when('documentType', {
    is: (documentType) => ['PASSPORT', 'VISA', 'driving_license', 'SSN'].includes(documentType),
    then: () => Yup.string().required('Expiry date is required for this document type'),
    otherwise: () => Yup.string().notRequired()
  })
});

export const timeSheetValidationSchema = Yup.object({
  projectId: Yup.string().required("Project is required"),
  work_location: Yup.string().required("Work location is required"),
  startDate: Yup.date().required("Start date is required"),
  endDate: Yup.date()
    .required("End date is required")
    .min(Yup.ref("startDate"), "End date must be before Start date"),
  total_hours: Yup.number()
    .required("Total hours are required")
    .positive("Total hours must be greater than 0"),
  holidays: Yup.array().of(
    Yup.object({
      date: Yup.date().required("Holiday date is required"),
      note: Yup.string().required("Note is required"),
    })
  ),
});
export const statusValidationSchema = Yup.object({
  userId: Yup.object().required("Employee selection is required"),
  userStatus: Yup.string().required("Status is required"),
  startDate: Yup.date().required("Start date is required"),
  endDate: Yup.date()
    .required("End date is required")
    .min(Yup.ref("startDate"), "End date cannot be before start date"),
  statusCode: Yup.string().required("Status code is required"),
  // files: Yup.array()
  //   .min(1, "You must upload at least one file")
  //   .required("Files are required"),
});
